var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4675 0H6.53248C2.92469 0 0 2.79008 0 6.23182V39.5584C0 43.0001 2.92469 45.7902 6.53248 45.7902H41.4675C45.0753 45.7902 48 43.0001 48 39.5584V6.23182C48 2.79008 45.0753 0 41.4675 0Z",
    fill: "#111834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0362 35.09H18.9642C14.4941 35.09 10.8569 31.453 10.8569 26.9822V18.1068C10.8569 13.6366 14.4941 10 18.9642 10H29.0362C33.5059 10 37.1429 13.6366 37.1429 18.1068V26.9822C37.1429 31.4524 33.5059 35.09 29.0362 35.09ZM18.9642 11.8014C15.487 11.8014 12.6589 14.6301 12.6589 18.1068V26.9822C12.6589 30.4593 15.487 33.2876 18.9642 33.2876H29.0362C32.5128 33.2876 35.3416 30.4588 35.3416 26.9822V18.1068C35.3416 14.6301 32.5128 11.8014 29.0362 11.8014H18.9642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 29.7608C20.0208 29.7608 16.7839 26.5233 16.7839 22.5445C16.7839 18.5656 20.0208 15.3281 24.0002 15.3281C27.9797 15.3281 31.2165 18.5651 31.2165 22.5445C31.2165 26.5238 27.9797 29.7608 24.0002 29.7608ZM24.0002 17.1289C21.0144 17.1289 18.5853 19.558 18.5853 22.5438C18.5853 25.5297 21.0144 27.9589 24.0002 27.9589C26.9861 27.9589 29.4153 25.5297 29.4153 22.5438C29.4153 19.558 26.9861 17.1289 24.0002 17.1289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6034 15.5502C32.6034 16.3769 31.9331 17.047 31.1064 17.047C30.2797 17.047 29.6089 16.3769 29.6089 15.5502C29.6089 14.7234 30.2797 14.0526 31.1064 14.0526C31.9331 14.0526 32.6034 14.7229 32.6034 15.5502Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.98ec7ce0778e0ffa8f99fc5a376cfe97.svg";
export { ForwardRef as ReactComponent };